import * as FateActionTypes from 'actiontypes/fate';
import FateService from 'services/FateService';
import { fetchAvailable } from 'actions/storylet';
import { fetch as fetchCards } from 'actions/cards';

export const purchaseItemRequested = () => ({
  type: FateActionTypes.PURCHASE_ITEM_REQUESTED,
  isPurchasing: true,
});

export const purchaseItemSuccess = data => ({
  type: FateActionTypes.PURCHASE_ITEM_SUCCESS,
  isPurchasing: false,
  payload: data,
});

export const purchaseItemFailure = error => ({
  type: FateActionTypes.PURCHASE_ITEM_FAILURE,
  isPurchasing: false,
  error: true,
  status: error.response && error.response.status,
});

/** ----------------------------------------------------------------------------
 * PURCHASE ITEM
 -----------------------------------------------------------------------------*/

export default purchaseItem(new FateService());

export function purchaseItem(service) {
  return fateData => async (dispatch) => {
    dispatch(purchaseItemRequested());

    try {
      const { data } = await service.purchaseItem(fateData);
      dispatch(purchaseItemSuccess(data));
      // Fetch opp cards and available storylets in case one of them changed
      dispatch(fetchCards({ background: true }));
      dispatch(fetchAvailable());
      return data;
    } catch (error) {
      dispatch(purchaseItemFailure(error));
      return undefined;
    }
  };
}